
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.521","height":"21.521"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.76 1.793a8.967 8.967 0 11-8.967 8.967 8.977 8.977 0 018.967-8.967zm0-1.793a10.76 10.76 0 1010.76 10.76A10.761 10.761 0 0010.76 0zm3.94 6.725l-5.06 5.187-2.371-2.247L5.6 11.331l4.04 3.913 6.725-6.854L14.7 6.725z"}})])
          )
        }
      }
    